export enum SessionDialogMode {
  none,
  edit,
  visualize,
}
